import { BayLevelEnum, IBayLevelData, IOpenVesselDefinitionV1 } from "open-vessel-definition";
import { pad3, sortByMultipleFields } from "@tedivo/tedivo-pure-helpers";

import { IBayPattern } from "@tedivo/tedivo-bay-grid-pure";

export function fixMissingBaysData(json: IOpenVesselDefinitionV1): IOpenVesselDefinitionV1 {
  const maxBay = json.sizeSummary.isoBays;
  if (!maxBay) return json;

  const baysDataDict: Record<`${IBayPattern}-${BayLevelEnum}`, IBayLevelData> = {};

  json.baysData.forEach((bayLevel) => {
    baysDataDict[`${bayLevel.isoBay}-${bayLevel.level}`] = bayLevel;
  });

  const allBays = Array
    .from({ length: maxBay }, (_, i) => (i + 1))
    .filter((b) => b % 2 !== 0)
    .map((b) => pad3(b)) as IBayPattern[];

  const newBaysData: IBayLevelData[] = [];

  allBays.forEach((bay) => {
    [BayLevelEnum.ABOVE, BayLevelEnum.BELOW].forEach((level) => {
      const bayAndLevel = `${bay}-${level}` as `${IBayPattern}-${BayLevelEnum}`;

      if (baysDataDict[bayAndLevel]) {
        newBaysData.push(baysDataDict[bayAndLevel]);
      } else {
        newBaysData.push({
          isoBay: bay,
          level: Number(level),
          infoByContLength: {},
          perSlotInfo: {},
        });
      }
    });
  });

  return {
    ...json,
    baysData: newBaysData.sort(
      sortByMultipleFields([
        { name: "isoBay", ascending: true },
        { name: "level", ascending: true },
      ]),
    ),
  };
}